export default __webpack_public_path__ + "b7e4ee5a64d9413e3a6cff1ddfc2a2aa.jpg";